import React from "react";

import "./WordDivider.scss";

const WordDivider = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="word-container">
      <hr className="word-divider" />
      <p>{children}</p>
      <hr className="word-divider" />
    </div>
  );
};

export default WordDivider;
